import { Box, Center, Text, useColorModeValue } from '@chakra-ui/react';

interface IPedidoBox {
  titulo?: string;
  children?: any;
  dependencia?: any;
  error?: any;
}

const PedidoBox: React.FC<IPedidoBox> = ({
  titulo,
  children,
  dependencia,
  error,
}) => {
  const blue = useColorModeValue('#2b6cb0', '#90cdf4');
  const bg = useColorModeValue('white', 'gray.800');
  const show = dependencia !== '';

  return (
    <Box borderWidth="2px" p="1" borderColor={error ? 'tomato' : 'inherit'}>
      <Text
        fontWeight="medium"
        color={bg}
        bg={show ? blue : `${blue}66`}
        p="2"
        //
      >
        {titulo}
      </Text>
      {dependencia !== '' && children}
    </Box>
  );
};

export default PedidoBox;
